import fetcher from '@/lib/fetcher'
import dayjs from 'dayjs'

export const stockKline = async (code, {
  startDate = undefined,
  endDate = undefined
} = {}) => {
  const fmt = 'MM/DD/YYYY'
  let query = {}

  if (
    startDate &&
    endDate &&
    dayjs(startDate).isValid() &&
    dayjs(endDate).isValid()
  ) {
    query = {
      startDate: dayjs(startDate).format(fmt),
      endDate: dayjs(endDate).format(fmt),
    }
  } else {
    query = {
      startDate: !startDate
        ? dayjs(startDate).subtract(14, 'd').format(fmt)
        : dayjs(startDate).format(fmt),
      endDate: dayjs(endDate).format(fmt)
    }
  }
  return fetcher(`/api/stocks/${code}/chart`, { query })
}

export const getMultiByCodes = async (codes = []) => {
  try {
    const res = await fetcher('/api/stocks/get-multiple-id', {
      config: {
        method: 'POST',
        body: JSON.stringify({ id: codes })
      }
    })

    return res
  } catch (e) {
    throw e
  }
}

export const themeList = async (query) => {
  const _query = {
    type: 'thematic',
    page: 1,
    ...query,
  }
  
  return fetcher(`/api/stocks/thematic`, { query: _query })
}

export const themeById = async (id) => {
  
}
